/* eslint eol-last:0 */
export default [
    {
        path: "/initialization/version",
        name: "版本选择",
        component: (resolve) => require(["../../views/initialization/version"], resolve),
        meta: {
            permission: "Pages.ModuleSelect",
            requireAuthorized: true,
            title: "版本选择",
        },
    },
    {
        path: "/initialization/workFlow",
        name: "配置详情",
        component: (resolve) => require(["../../views/initialization/workFlow"], resolve),
        meta: {
            permission: "Pages.WorkFlowApp",
            requireAuthorized: true,
            title: "配置详情",
        },
    },
    {
        path: "/initialization/userVersion",
        name: "用户版本选择",
        component: (resolve) => require(["../../views/initialization/userVersion"], resolve),
        meta: {
            permission: "Pages.PurchasedModuleUser",
            requireAuthorized: true,
            title: "用户版本选择",
        },
    },
    {
        path: "/initialization/graph",
        name: "财务通数据流转图",
        component: (resolve) => require(["../../views/initialization/graph"], resolve),
        meta: {
            permission: "Pages.AccountConfInfos",
            requireAuthorized: false,
            title: "财务通数据流转图",
        },
    },
    {
        path: "/initialization/purchased",
        name: "已购模块",
        component: (resolve) => require(["../../views/initialization/purchasedAdmin"], resolve),
        meta: {
            permission: "Pages.PurchasedModuleConfs",
            requireAuthorized: true,
            title: "已购模块",
        },
    },
    {
        path: "/initialization/storeAuthorize",
        name: "门店授权",
        component: (resolve) =>
            require(["../../views/initialization/storeAuthorizeAdmin"], resolve),
        meta: {
            permission: "Pages.StoreAuthorizes",
            requireAuthorized: true,
            title: "门店授权",
        },
    },
    {
        path: "/initialization/storeAuthorizeList",
        name: "门店授权列表",
        component: (resolve) => require(["../../views/initialization/storeAuthorizeList"], resolve),
        meta: {
            permission: "Pages.StoreAuthorizes",
            requireAuthorized: true,
            title: "门店授权列表",
        },
    },
    {
        path: "/initialization/voucherRecordView",
        name: "自动任务查看",
        component: (resolve) =>
            require(["../../views/initialization/voucherRecordView"], resolve),
        meta: {
            permission: "Pages.VoucherRecordViews",
            requireAuthorized: true,
            title: "自动任务查看",
        },
    },
    // {
    //     path: '/voucherAdmin/index',
    //     name: '凭证管理',
    //     component: resolve =>
    //         require(['../../views/voucherAdmin/index'], resolve),
    //     meta: {
    //         permission: 'Pages.voucher',
    //         requireAuthorized: true,
    //         title: '凭证管理'
    //     }
    // },
    {
        path: "/initialization/brand",
        name: "品牌管理",
        component: (resolve) => require(["../../views/initialization/brand"], resolve),
        meta: {
            permission: "Pages.BussinessBrandInfos",
            requireAuthorized: true,
            title: "品牌管理",
        },
    },
    {
        path: "/initialization/environment",
        name: "环境设置",
        component: (resolve) => require(["../../views/initialization/environment"], resolve),
        meta: {
            permission: "Pages.EnvironmentConfs",
            requireAuthorized: true,
            title: "环境设置",
        },
    },
    {
        path: "/initialization/control",
        name: "控制设置",
        component: (resolve) => require(["../../views/initialization/control"], resolve),
        meta: {
            permission: "Pages.BussinessModules",
            requireAuthorized: true,
            title: "控制设置",
        },
    },
    {
        path: "/initialization/system",
        name: "系统设置",
        component: (resolve) => require(["../../views/initialization/system"], resolve),
        meta: {
            permission: "Pages.BussinessModules",
            requireAuthorized: true,
            title: "系统设置",
        },
    },
    {
        path: "/initialization/storeAdmin",
        name: "门店管理",
        component: (resolve) => require(["../../views/initialization/storeAdmin"], resolve),
        meta: {
            permission: "Pages.BussinessStoreInfos",
            requireAuthorized: true,
            title: "门店管理",
        },
    },
    {
        path: "/initialization/userAccount",
        name: "账套信息",
        component: (resolve) => require(["../../views/initialization/userAccount"], resolve),
        meta: {
            permission: "Pages.AccountConfInfosUser",
            requireAuthorized: true,
            title: "账套信息",
        },
    },
    {
        path: "/bench/index",
        name: "基础档案",
        component: (resolve) => require(["../../views/bench/index"], resolve),
        meta: {
            permission: "Pages.BasicDataList",
            requireAuthorized: true,
            title: "基础档案",
        },
    },
    {
        path: "/bench/edit",
        name: "档案编辑",
        component: (resolve) => require(["../../views/bench/edit"], resolve),
        meta: {
            permission: "Pages.BasicDataList",
            requireAuthorized: true,
            title: "档案编辑",
        },
    },
    {
        path: "/order/cloudorder",
        name: "云供应链单据",
        component: (resolve) => require(["../../views/order/cloudorder"], resolve),
        meta: {
            permission: "Pages.CloudSupplyOrder",
            requireAuthorized: true,
            title: "云供应链单据",
        },
    },
    {
        path: "/bench/businessOrder",
        name: "业务单据维护",
        component: (resolve) => require(["../../views/bench/businessOrder"], resolve),
        meta: {
            permission: "Pages.BussinessOrderManagers",
            requireAuthorized: true,
            title: "业务单据维护",
        },
    },
    //   {
    //     path: "/order/kisorder",
    //     name: "KIS业务单据",
    //     component: (resolve) => require(["../../views/order/kisorder"], resolve),
    //     meta: {
    //       permission: "Pages.BusinessOrder",
    //       requireAuthorized: true,
    //       title: "业务单据",
    //     },
    //   },
    {
        path: "/admin/erp",
        name: "ERP版本管理",
        component: (resolve) => require(["../../views/admin/erpAdmin"], resolve),
        meta: {
            permission: "Pages.ERPSystemVersionInfos",
            requireAuthorized: true,
            title: "ERP版本管理",
        },
    },
    {
        path: "/admin/moduleAdmin",
        name: "系统模块管理",
        component: (resolve) => require(["../../views/admin/moduleAdmin"], resolve),
        meta: {
            permission: "Pages.BussinessModules",
            requireAuthorized: true,
            title: "系统模块管理",
        },
    },
    {
        path: "/admin/accountAdmin",
        name: "账套管理",
        component: (resolve) => require(["../../views/admin/accountAdmin"], resolve),
        meta: {
            permission: "Pages.AccountConfInfos",
            requireAuthorized: true,
            title: "账套管理",
        },
    },
    {
        path: "/initialization/taskLog",
        name: "任务日志",
        component: (resolve) => require(["../../views/initialization/taskLog"], resolve),
        meta: {
            permission: "Pages.HangfireAccount",
            requireAuthorized: true,
            title: "任务日志",
        },
    },
    //   {
    //     path: "/admin/bussinessOrder",
    //     name: "业务单据维护",
    //     component: (resolve) =>
    //       require(["../../views/admin/bussinessOrder"], resolve),
    //     meta: {
    //       permission: "Pages.BussinessOrderManagers",
    //       requireAuthorized: true,
    //       title: "业务单据维护",
    //     },
    //   },
    {
        path: "/admin/basicInfoType",
        name: "基础资料类别",
        component: (resolve) => require(["../../views/admin/basicInfoType"], resolve),
        meta: {
            permission: "Pages.BasicInfoTypes",
            requireAuthorized: true,
            title: "基础资料类别",
        },
    },
    {
        path: "/admin/infoMenu",
        name: "基础资料维护",
        component: (resolve) => require(["../../views/admin/infoMenu"], resolve),
        meta: {
            permission: "Pages.BasicDatas",
            requireAuthorized: true,
            title: "基础资料维护",
        },
    },
    {
        path: "/admin/basicField",
        name: "基础字段维护",
        component: (resolve) => require(["../../views/admin/basicFieldAdmin"], resolve),
        meta: {
            permission: "Pages.BasicFields",
            requireAuthorized: true,
            title: "基础字段维护",
        },
    },
    {
        path: "/admin/expField",
        name: "摘要字段维护",
        component: (resolve) => require(["../../views/admin/explanationField"], resolve),
        meta: {
            permission: "Pages.ExpFields",
            requireAuthorized: true,
            title: "摘要字段维护",
        },
    },
    {
        path: "/subject/subjectType",
        name: "科目类别维护",
        component: (resolve) => require(["../../views/subject/subjectType"], resolve),
        meta: {
            permission: "Pages.SubjectTypes",
            requireAuthorized: true,
            title: "科目类别维护",
        },
    },
    {
        path: "/subject/subjectField",
        name: "科目字段维护",
        component: (resolve) => require(["../../views/subject/subjectField"], resolve),
        meta: {
            permission: "Pages.SubjectFields",
            requireAuthorized: true,
            title: "科目字段维护",
        },
    },
    {
        path: "/subject/subjectTypeUser",
        name: "科目类别信息",
        component: (resolve) => require(["../../views/subject/subjectTypeUser"], resolve),
        meta: {
            permission: "Pages.SubjectTypeUsers",
            requireAuthorized: true,
            title: "科目类别信息",
        },
    },
    {
        path: "/subject/subjectFieldUser",
        name: "科目字段信息",
        component: (resolve) => require(["../../views/subject/subjectFieldUser"], resolve),
        meta: {
            permission: "Pages.SubjectFieldUsers",
            requireAuthorized: true,
            title: "科目字段信息",
        },
    },
    {
        path: "/voucher/subject",
        name: "科目管理",
        component: (resolve) => require(["../../views/voucherAdmin/subject.vue"], resolve),
        meta: {
            permission: "Pages.SubjectDetails",
            requireAuthorized: false,
            title: "科目管理",
        },
    },
    {
        path: "/voucher/subjectrelation",
        name: "科目关系管理",
        component: (resolve) => require(["../../views/voucherAdmin/subjectRelation.vue"], resolve),
        meta: {
            permission: "Pages.SubjectRelations",
            requireAuthorized: false,
            title: "科目关系管理",
        },
    },
    {
        path: "/voucher/subjectExplanation",
        name: "摘要设置",
        component: (resolve) =>
            require(["../../views/voucherAdmin/subjectExplanation.vue"], resolve),
        meta: {
            permission: "Pages.SubjectDetails",
            requireAuthorized: false,
            title: "摘要设置",
        },
    },
    {
        path: "/voucher/voucherManager",
        name: "凭证管理",
        component: (resolve) => require(["../../views/voucherAdmin/voucherManager.vue"], resolve),
        meta: {
            permission: "Pages.VoucherManager",
            requireAuthorized: true,
            title: "凭证管理",
        },
    },
    {
        path: "/voucher/voucherCreate",
        name: "凭证生成",
        component: (resolve) => require(["../../views/voucherAdmin/voucherCreate.vue"], resolve),
        meta: {
            permission: "Pages.VoucherCreate",
            requireAuthorized: true,
            title: "凭证生成",
        },
    },
    {
        path: "/voucher/voucherlogs",
        name: "手工传输凭证日志",
        component: (resolve) => require(["../../views/voucherAdmin/voucherLogs.vue"], resolve),
        meta: {
            permission: "Pages.VoucherLogs",
            requireAuthorized: true,
            title: "手工传输凭证日志",
        },
    },
    {
        path: "/voucher/hangfireVoucher",
        name: "自动生成凭证记录",
        component: (resolve) => require(["../../views/voucherAdmin/hangfireVoucher.vue"], resolve),
        meta: {
            permission: "Pages.HangfireVouchers",
            requireAuthorized: true,
            title: "自动生成凭证记录",
        },
    },
    {
        path: "/voucher/sysoplogs",
        name: "操作日志",
        component: (resolve) => require(["../../views/voucherAdmin/sysOpLogs.vue"], resolve),
        meta: {
            permission: "Pages.SysOpLogs",
            requireAuthorized: true,
            title: "操作日志",
        },
    },
    {
        path: "/order/orderCreate",
        name: "单据同步",
        component: (resolve) => require(["../../views/orderAdmin/orderCreate.vue"], resolve),
        meta: {
            permission: "Pages.OrderCreate",
            requireAuthorized: true,
            title: "单据同步",
        },
    },
    {
        path: "/order/orderManager",
        name: "单据管理",
        component: (resolve) => require(["../../views/orderAdmin/orderManager.vue"], resolve),
        meta: {
            permission: "Pages.OrderManager",
            requireAuthorized: true,
            title: "单据管理",
        },
    },
    {
        path: "/api/apiCheck",
        name: "接口检测",
        component: (resolve) => require(["../../views/apiAdmin/apiCheck.vue"], resolve),
        meta: {
            permission: "Pages.ApiCheck",
            requireAuthorized: true,
            title: "接口检测",
        },
    },
    {
        path: "/helpCenter/questionClass",
        name: "问题分类",
        component: (resolve) => require(["../../views/helpCenter/questionClass.vue"], resolve),
        meta: {
            permission: "Pages.QuestionClasses",
            requireAuthorized: true,
            title: "问题分类",
        },
    },
    {
        path: "/helpCenter/questionAdmin",
        name: "问题管理",
        component: (resolve) => require(["../../views/helpCenter/questionAdmin.vue"], resolve),
        meta: {
            permission: "Pages.QuestionAdmins",
            requireAuthorized: true,
            title: "问题管理",
        },
    },
    {
        path: "/helpCenter/questionAdminUser",
        name: "查看问题",
        component: (resolve) => require(["../../views/helpCenter/questionAdminUser"], resolve),
        meta: {
            permission: "Pages.QuestionAdminUsers",
            requireAuthorized: false,
            title: "查看问题",
        },
    },
    {
        path: "/helpCenter/workBookAdmin",
        name: "操作手册管理",
        component: (resolve) => require(["../../views/helpCenter/workBookAdmin"], resolve),
        meta: {
            permission: "Pages.WorkBookAdmins",
            requireAuthorized: false,
            title: "操作手册管理",
        },
    },
    {
        path: "/helpCenter/workBookUser",
        name: "操作手册",
        component: (resolve) => require(["../../views/helpCenter/workBookUser"], resolve),
        meta: {
            permission: "",
            requireAuthorized: false,
            title: "操作手册",
        },
    },
    {
        path: "/admin/voucherControl",
        name: "凭证控制",
        component: (resolve) => require(["../../views/admin/voucherControl"], resolve),
        meta: {
            permission: "Pages.AccountConfInfos",
            requireAuthorized: false,
            title: "凭证控制",
        },
    },
    {
        path: "/billType/billTypes",
        name: "单据类型维护",
        component: (resolve) => require(["../../views/billType/billType"], resolve),
        meta: {
            permission: "Pages.BillTypes",
            requireAuthorized: true,
            title: "单据类型维护",
        },
    },
];
